import React, { useRef } from 'react';
import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button } from '@chakra-ui/react';
import { FocusableElement } from '../../../types/chakra';

type ConfirmCouponUseDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConfirmCouponUseDialog: React.FC<ConfirmCouponUseDialogProps> = ({ isOpen, onClose, onConfirm }) => {
  const cancelRef = useRef<HTMLButtonElement>(null);
  const focusRef = useRef<HTMLButtonElement>(null) as React.RefObject<FocusableElement>;

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={focusRef}
      onClose={onClose}
      size='xs'
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize='lg' fontWeight='bold'>
            クーポンを使用しますか？
          </AlertDialogHeader>

          <AlertDialogBody>
            このクーポンは使用後、無効になります。
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              キャンセル
            </Button>
            <Button colorScheme='red' onClick={onConfirm} ml={3}>
              使用する
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};